import { Helmet } from "react-helmet-async";

const CANONICAL_DOMAIN = "https://www.pureproindia.in";

interface SEOHeadProps {
  title?: string;
  description?: string;
  path?: string;
  ogImage?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, any> | Record<string, any>[];
  keywords?: string;
}

const SEOHead = ({
  title,
  description,
  path = "",
  ogImage = "/images/hero-banner.jpg",
  noIndex = false,
  jsonLd,
  keywords,
}: SEOHeadProps) => {
  const fullTitle = title
    ? `${title} — PurePro India`
    : "PurePro India — Best Water Ionizer & RO Systems in India";
  const metaDescription =
    description ||
    "Buy premium water ionizers, alkaline water machines, RO systems & hydrogen water products from PurePro India. Made in USA. Trusted across India.";
  const canonicalUrl = `${CANONICAL_DOMAIN}${path}`;
  const ogImageUrl = ogImage.startsWith("http")
    ? ogImage
    : `${CANONICAL_DOMAIN}${ogImage}`;

  const jsonLdArray = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />}
      {keywords && <meta name="keywords" content={keywords} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PurePro India" />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImageUrl} />

      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="New Delhi, India" />

      {jsonLdArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
